import React from 'react';

export const CreateDepartments = React.lazy(
  () => import('./CreateDepartments/CreateDepartments')
);

export const EditDepartments = React.lazy(
  () => import('./EditDepartments/EditDepartments')
);
